module.exports = __webpack_public_path__ + "media/metronic/_theme/media/demos/preview/demo17-5295c10f408515ba41186ee939ec399d.jpg";